<div class="space-y-4">
  <p hlmMuted class="text-sm">
    @if (audience() === 'member') {
      Auf dieses Konto überweist dir die Zentrale einmal im Monat den Betrag deiner Einlösungen.
    } @else {
      Von diesem Konto überweist du deinen Mitgliedern ihre monatliche Abrechnung. Es steht als
      Auftraggeber in der Sammelüberweisung.
    }
  </p>

  @if (!showForm()) {
    <div class="flex flex-wrap items-center justify-between gap-3 rounded-md border p-3">
      <div class="flex items-center gap-3">
        <ng-icon name="lucideLandmark" />
        <div>
          <p class="font-mono text-sm">{{ company()?.bank_iban_masked }}</p>
          <p hlmMuted class="text-xs">
            {{ company()?.bank_account_holder }}
            @if (company()?.bank_bic) {
              · {{ company()?.bank_bic }}
            }
          </p>
        </div>
      </div>
      <button hlmBtn variant="outline" size="sm" type="button" (click)="startEditing()">
        Ändern
      </button>
    </div>
    @if (pendingIban()) {
      <div hlmAlert>
        <ng-icon name="lucideMail" />
        <p hlmAlertTitle>Neue IBAN wartet auf deine Bestätigung</p>
        <p hlmAlertDescription>
          Wir haben dir an {{ company()?.email }} einen Link geschickt, mit dem du
          <span class="font-mono">{{ pendingIban() }}</span> bestätigst (gültig bis
          {{ pendingUntil() }}). Bis dahin überweist die Zentrale weiter auf die IBAN oben.
        </p>
        <button
          hlmBtn
          variant="outline"
          size="sm"
          type="button"
          class="mt-2"
          [disabled]="cancelling()"
          (click)="cancelPending()">
          Änderung zurückziehen
        </button>
      </div>
    } @else if (success()) {
      <p hlmMuted class="text-sm">Bankverbindung gespeichert.</p>
    }
  } @else {
    <form class="space-y-4" (ngSubmit)="submit()">
      @if (editing() && company()?.has_bank_account) {
        <!-- Changing starts from an empty field, so show what stays in place until then. -->
        <div class="flex items-center gap-3 rounded-md border border-dashed p-3">
          <ng-icon name="lucideLandmark" />
          <div>
            <p hlmMuted class="text-xs">Aktuelle Bankverbindung</p>
            <p class="font-mono text-sm">{{ company()?.bank_iban_masked }}</p>
            <p hlmMuted class="text-xs">
              @if (audience() === 'member') {
                Bleibt bestehen, bis du die neue IBAN speicherst und per E-Mail bestätigst.
              } @else {
                Bleibt bestehen, bis du die neue IBAN speicherst.
              }
            </p>
          </div>
        </div>
      }

      <div hlmField>
        <label hlmFieldLabel for="bank-iban">{{ editing() ? 'Neue IBAN' : 'IBAN' }}</label>
        <input
          hlmInput
          id="bank-iban"
          name="iban"
          class="font-mono"
          autocomplete="off"
          placeholder="DE89 3704 0044 0532 0130 00"
          [maskito]="ibanMask"
          [ngModel]="iban()"
          (ngModelChange)="iban.set($event)"
          (blur)="touched.set(true)"
          [attr.aria-invalid]="ibanProblem() ? 'true' : null" />
        @if (ibanProblem()) {
          <p hlmFieldDescription class="text-destructive">{{ ibanProblem() }}</p>
        }
      </div>

      <div hlmField>
        <label hlmFieldLabel for="bank-holder">Kontoinhaber</label>
        <input
          hlmInput
          id="bank-holder"
          name="holder"
          maxlength="70"
          [ngModel]="holder()"
          (ngModelChange)="holder.set($event)" />
      </div>

      <div hlmField>
        <label hlmFieldLabel for="bank-bic">BIC (optional)</label>
        <input
          hlmInput
          id="bank-bic"
          name="bic"
          class="font-mono sm:w-56"
          maxlength="11"
          [ngModel]="bic()"
          (ngModelChange)="bic.set($event)" />
      </div>

      @if (audience() === 'member' && company()?.has_bank_account) {
        <div hlmAlert>
          <ng-icon name="lucideTriangleAlert" />
          <p hlmAlertDescription>
            Eine neue IBAN gilt erst, wenn du sie über den Link bestätigst, den wir dir per E-Mail
            schicken. Danach wird deine Zentrale informiert und sieht die Änderung in der nächsten
            Abrechnung.
          </p>
        </div>
      }

      @if (error()) {
        <p class="text-destructive text-sm">{{ error() }}</p>
      }

      <div class="flex gap-2">
        <button hlmBtn type="submit" [disabled]="saving()">
          @if (saving()) {
            <hlm-spinner />
          }
          {{ submitLabel() }}
        </button>
        @if (editing()) {
          <button hlmBtn variant="ghost" type="button" (click)="editing.set(false)">
            Abbrechen
          </button>
        }
      </div>
    </form>
  }
</div>
